import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink,
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/mindfulness";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllMindfulnessByTax(params.tratamientoId);
}

export function MindfulnessList(props) {
  const [mindfulnessList, setMindfulness] = useState([]);
  let { tratamientoId } = useParams();

  useEffect(() => {
    API.getAllMindfulnessByTax(props.id)
      .then(setMindfulness)
      .catch(console.log);
  }, [props.id]);
  return (
    <>
      {mindfulnessList?.length ? (
        <ul className='mindfulness cpt-list'>
          {mindfulnessList
            .sort((a, b) => {
              // Convertir las fechas a objetos de fecha para comparar
              const dateA = new Date(a.meta.metaFecha);
              const dateB = new Date(b.meta.metaFecha);
              // Ordenar de manera descendente (más reciente primero)
              return dateB - dateA;
            })
            .map((mindfulness) => (
              <li key={mindfulness.id}>
                <NavLink
                  to={`${props.id}/seguimiento/mindfulness/${mindfulness.id}`}
                >
                  {`Sesión ${mindfulness.meta.mindNumses}`} -{" "}
                  {`${FormatDate(mindfulness.meta.metaFecha)}`}
                </NavLink>
              </li>
            ))}
        </ul>

      ) : (
        <></>
      )}
    </>
  );
}

export function MindfulnessListContent(props) {
  let { tratamientoId } = useParams();

  return (
    <>
      <div id='content'>
        <h1>Mindfulness</h1>
      </div>
      <div id='actions'>
      {(props.userRole.includes('administrador') || props.userRole.includes('mindfulness')) && (
          <Link className='button is-link' to={`new`}>
            Nuevo
          </Link>
      )}
      </div>
    </>
  );
}
